import { Unifree } from '@yes.technology/react-toolkit'
import React from 'react'
import { useTranslation } from 'react-i18n-lite'
import CompositionButtons from '../CompositionButtons/CompositionButtons'

type FilterCompositionProps = {
  composition: string
  handleComposition: (composition: string) => void
  handleCreateGroup: () => void
}

function FilterComposition({
  composition,
  handleComposition,
  handleCreateGroup
}: FilterCompositionProps) {
  const { t } = useTranslation()

  return (
    <>
      <div
        className='d-md-grid d-flex flex-column gap-2'
        style={{ gridAutoFlow: 'column' }}
      >
        <Unifree
          label='Composição da Ação de Filtragem'
          value={composition.replace(/\b(AND|OR)\b/gi, (match) =>
            match.toUpperCase() === 'AND'
              ? t('composition-operator.and')
              : t('composition-operator.or')
          )}
          informational
        />
      </div>
      <CompositionButtons
        {...{ composition, handleComposition, handleCreateGroup }}
      />
    </>
  )
}

export default FilterComposition
